import { useMemo, ComponentProps } from 'react';
import { Text, TextLink } from '@updater/ui-uds';

import { useFYMStatus } from 'flows/core/hooks/use-user-move-type';
import { useTracking } from 'react-tracking';

export type SubtitleProps = ComponentProps<typeof Text> & {
  showStatusByDefault?: boolean;
};

/**
 * Business logic from [this ticket](https://app.clickup.com/t/862j93t6r).
 */
export const Subtitle: React.FC<SubtitleProps> = ({
  showStatusByDefault,
  ...rest
}) => {
  const fymStatus = useFYMStatus();

  const { trackEvent } = useTracking();

  const subtitle = useMemo(() => {
    if (showStatusByDefault || fymStatus?.forwardMailRequestCount >= 1)
      return (
        <Text as="p" variant="m" {...rest}>
          Please allow up to 14 business days for mail forwarding to begin. You
          can file a maximum of 2 mail-forwarding requests. For additional mail
          forwarding, please{' '}
          <TextLink
            target="__blank"
            onClick={() =>
              trackEvent({
                object: 'USPSAdditionalMailForwarding',
                verb: 'clicked',
              })
            }
            href="https://moversguide.usps.com/mgo/disclaimer"
          >
            click here
          </TextLink>{' '}
          or visit your local Post Office&trade; locations.
        </Text>
      );
    return null;
  }, [
    fymStatus?.forwardMailRequestCount,
    rest,
    showStatusByDefault,
    trackEvent,
  ]);

  return subtitle;
};
